<template>
  <div>
    <BaseHeadline icon="mdi-calendar-month">
      <template v-slot:headlineBtns>
        <v-btn color="primary"> Legg til booking </v-btn>
      </template>
    </BaseHeadline>

    <v-alert class="mt-2" color="info">
      Dette er booking av rom på brakkerigg. Her kan du legge inn fra til dato
      for når du ønsker å reservere et rom. Du kan kun ha èn aktiv booking per
      dag.
    </v-alert>

    <BookingCalendar
      class="mt-4"
      @save="dateChanged"
      @open="barracksAvailable = []"
    />

    <div v-for="barrack in barracksAvailable" :key="barrack.id">
      <v-card class="px-3 pb-2 mb-5" color="cardSurfaceDark" elevation="0">
        <v-list class="pb-0" color="transparent">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="headline font-weight-bold">
                {{ barrack.name }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ barrack.location }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </v-list>

        <v-alert v-if="barrack.barrackRooms.length === 0" color="warning">
          {{ barrack.name }} har ingen rom tilgjengelig i den angitte perioden
        </v-alert>

        <CaseCardList
          class="pb-2"
          v-model="barrack.barrackRooms"
          titleKey="name"
          underRightKey="orderDate"
          underLeftKey="contactName"
          deadlineKey="deliveryDate"
          mt="mt-1"
          removeArrowIcon
          removeBottom
          removeBottomLoading
          @click="addBooking($event, barrack)"
        >
          <template v-slot:chips="{ item }">
            <slot name="chips" :item="item">
              <div>
                <v-chip color="success" class="mr-2" small>Ledig</v-chip>
              </div>
            </slot>
          </template>

          <template v-slot:deadline>
            <v-btn class="mb-1" color="primary" depressed small>
              Reserver rom
            </v-btn>
          </template>
        </CaseCardList>
      </v-card>
    </div>
    <ConfirmDialog
      v-model="showConfirm"
      title="Bekreft"
      icon="mdi-calendar-check "
      :text="confirmText"
      btnActionName="Bekreft"
      btnCloseName="Avbryt"
      @action="saveBooking"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import barracksApi from "@/api/barracksApi";
import notification from "@/helpers/notification";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import BookingCalendar from "@/components/projects/project/bookings/booking/children/BookingCalendar.vue";
import CaseCardList from "@/components/shared/cards/CaseCardList.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";

export default Vue.extend({
  name: "Dashboard",
  data() {
    return {
      projectId: "",
      barracksAvailable: [],
      fromDate: "",
      toDate: "",
      showConfirm: false,
      confirmText: "",
      booking: {},
    };
  },
  mounted() {
    this.projectId = this.$route.params.id;
  },

  methods: {
    ...mapActions({
      setBookingActive: "profile/setBookingActive",
    }),
    dateChanged(date) {
      this.fromDate = date[0];
      this.toDate = date[1];
      //Need to and from date
      if (this.fromDate && this.toDate) {
        var data = {
          projectId: this.projectId,
          fromDate: date[0],
          toDate: date[1],
        };
        barracksApi.getBookingBarracksAvailableRooms(data).then((res) => {
          this.barracksAvailable = res;
        });
      }
    },
    addBooking(room, barrack) {
      this.booking = {
        roomId: room.id,
        barracksProjectId: barrack.id,
        contactPersonId: this.profile.id,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };

      this.confirmText = `Vil du reservere ${room.name} på ${
        barrack.name
      } fra ${moment(this.fromDate).format("dddd DD.MM.YY")} til ${moment(
        this.toDate
      ).format("dddd DD.MM.YY")}?`;
      this.showConfirm = true;
    },
    saveBooking() {
      barracksApi.addBookingBarracks(this.booking).then(() => {
        notification.success(
          "Din reserversjon er lagt til! Du vil få en bekreftelse på mail"
        );
        this.$router.go(-1);
        this.setBookingActive();
      });
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
    }),
  },

  components: {
    BaseHeadline,
    BookingCalendar,
    CaseCardList,
    ConfirmDialog,
  },
});
</script>
